import {Box, Typography, css, styled} from '@mui/material';

const SectionContainer = styled(Box)<{$customPadding?: string}>`
	border-radius: 8px;
	border: 1px solid ${({theme}) => theme.palette.grey[300]};
	background: ${({theme}) => theme.palette.grey[100]};
	padding: 8px;
	display: flex;
	align-items: center;
	gap: 8px;
	flex: 1;
	width: -webkit-fill-available;

	${({$customPadding}) =>
		$customPadding &&
		css`
			padding: ${$customPadding};
		`}
`;

const ValueTypography = styled(Typography)<{$textOverflow?: boolean}>`
	flex: 1;
	${({$textOverflow}) =>
		$textOverflow &&
		css`
			width: 100%;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		`}
`;

export {SectionContainer, ValueTypography};
